import { render, staticRenderFns } from "./PersonalInfoCard.vue?vue&type=template&id=74e9938e&scoped=true&"
import script from "./PersonalInfoCard.vue?vue&type=script&lang=js&"
export * from "./PersonalInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./PersonalInfoCard.vue?vue&type=style&index=0&id=74e9938e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e9938e",
  null
  
)

export default component.exports